import { Box, makeStyles } from '@material-ui/core';
import { REQUEST_STATUS_ENUM } from '../../../../comm/constant';
import { i18n } from '../../../../language';

const useStyles = makeStyles(() => ({
  textKey: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
    marginRight: '0.2rem',
  },
  textValue: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.875rem',
    color: '#2e4469',
    lineHeight: '2.563rem',
    minWidth: '3.25rem',
    textAlign: 'center',
  },
  status: ({ backgroundColor }) => ({
    borderRadius: '50%',
    width: '0.625rem',
    height: '0.625rem',
    backgroundColor,
    marginRight: '0.625rem',
  }),
}));

const DisplayStatus = ({ enumKey, value }) => {
  const classes = useStyles({ backgroundColor: REQUEST_STATUS_ENUM[enumKey].color });

  return (
    <Box display="flex" alignItems="center">
      <div className={classes.status} />
      <div className={classes.textKey}>{`${i18n.t(REQUEST_STATUS_ENUM[enumKey].textKey)}:`}</div>
      <div className={classes.textValue}>{value}</div>
    </Box>
  );
};

const StatusBar = ({ data }) => {
  return (
    <Box
      display="flex"
      gridGap="0.4rem"
      borderRadius="15px"
      border="solid 1.2px #e4e7eb"
      padding="0.313rem 0.8rem 0.25rem"
    >
      <DisplayStatus enumKey="PENDING" value={data.pending} />
      <DisplayStatus enumKey="LOANED" value={data.loaned} />
      <DisplayStatus enumKey="DECLINED" value={data.declined} />
      <DisplayStatus enumKey="RETURNED" value={data.returned} />
      <DisplayStatus enumKey="WITHDRAWN" value={data.withdrawn} />
      <DisplayStatus enumKey="TRANSFER" value={data.transfer} />
    </Box>
  );
};

export default StatusBar;
